var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"inline-block fill-current",attrs:{"aria-hidden":"true","viewBox":"0 0 324 146","focusable":"false"}},[_c('path',{attrs:{"d":"M0 146.142c121.073 0 273.894.726 324.813.595.512-57.485-1.516-93.246 0-146.737h-9.567v20H30L8.444.778 0 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }